// extracted by mini-css-extract-plugin
module.exports = {"menu__title":"HeaderContinents_menu__title__1pIeq","submenu":"HeaderContinents_submenu__3Klfr","submenu__item":"HeaderContinents_submenu__item__26v19"};